import { app } from '../../config'

export default (to) => {
  window.document.title = 'Plataforma de Gestão'
  if (to.meta.title !== undefined) {
    window.document.title = 'Plataforma de Gestão' + ' | ' +  to.meta.title
  }
}
